import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 6.667A.667.667 0 0 0 11.333 6H3.607L5.14 4.473a.67.67 0 1 0-.947-.946L1.527 6.193a.67.67 0 0 0-.14.727.67.67 0 0 0 .613.413h9.333A.667.667 0 0 0 12 6.667m2.613 2.413A.67.67 0 0 0 14 8.667H4.667a.667.667 0 0 0 0 1.333h7.726l-1.533 1.527a.665.665 0 0 0 0 .946.665.665 0 0 0 .947 0l2.666-2.666a.67.67 0 0 0 .14-.727"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })